var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgDialogFailedDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 840,
    height: 205,
    viewBox: "0 0 840 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M550.776 93.0859C683.631 69.5025 828.93 -42.8729 931.443 18.6645C1040.19 83.9424 957.971 229.39 972.745 337.91C981.877 404.989 1162.85 566.654 1150.39 634.591C1138.13 701.418 953.916 664.522 902.438 721.123C848.723 780.184 778.87 826.346 700.679 865.769C604.408 914.307 317.518 930.021 207.181 942.283C89.5826 942.353 158.429 824.033 86.7376 755.861C41.8856 713.211 43.1862 701.317 18.0956 616.364C-8.78018 525.367 -120.223 398.327 -82.5355 306.089C-44.5509 213.124 75.7512 155.936 182.859 120.34C313.765 76.8359 437.996 113.106 550.776 93.0859Z",
    fill: "#CDD5D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M550.776 93.0859C683.631 69.5025 828.93 -42.8729 931.443 18.6645C1040.19 83.9424 957.971 229.39 972.745 337.91C981.877 404.989 1162.85 566.654 1150.39 634.591C1138.13 701.418 953.916 664.522 902.438 721.123C848.723 780.184 778.87 826.346 700.679 865.769C604.408 914.307 317.518 930.021 207.181 942.283C89.5826 942.353 158.429 824.033 86.7376 755.861C41.8856 713.211 43.1862 701.317 18.0956 616.364C-8.78018 525.367 -120.223 398.327 -82.5355 306.089C-44.5509 213.124 75.7512 155.936 182.859 120.34C313.765 76.8359 437.996 113.106 550.776 93.0859Z",
    fill: "url(#pattern0_22442_68694)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_22442_68694",
    patternContentUnits: "objectBoundingBox",
    width: 0.00389294,
    height: 0.00537514
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_22442_68694",
    transform: "scale(0.000243309 0.000335946)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_22442_68694",
    width: 16,
    height: 16,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAuSURBVHgB7ZKxDQAACMLE/39WL4DBxRi6QjoQUEMQMLA8Y4kFFwRQBfUTj/hC0AhaCBsbu2V8AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgDialogFailedDesktop);
export default __webpack_public_path__ + "static/media/bg-dialog-failed-desktop.ac3e96907efce64907d2c2d97759bdf7.svg";
export { ForwardRef as ReactComponent };